import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';

import 'katex/dist/katex.min.css';
import 'highlight.js/styles/github.css';

const preprocessMarkdown = (content: string) => {
  content = content.replace(/\\\((.*?)\\\)/g, (_, expr) => `$${expr}$`);

  content = content.replace(
    /\\\[((?:.|\n)*?)\\\]/g,
    (_, expr) => `$$${expr}$$`
  );

  return content;
};

interface MarkdownRendererProps {
  content: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content,
}) => {
  const processedContent = preprocessMarkdown(content);
  return (
    <div className="chat-message markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeRaw, rehypeKatex as any, rehypeHighlight as any]}
      >
        {processedContent}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
